import classNames from "classnames";
import { useMemo } from "react";
import { buildStyles, CircularProgressbar } from "react-circular-progressbar";
import styles from "./AscCircularProgressBar.module.scss";

export interface AscCircularProgressBarProps {
  percentage: number;
  color?: string; // to set color of progress bar using js
  className?: string; // set color value to set color of progress bar using css
  decimalPlaces?: 0 | 1 | 2;
  hideNumber?: boolean;
}

function AscCircularProgressBar({
  percentage,
  color,
  className,
  decimalPlaces = 2,
  hideNumber= false,
}: AscCircularProgressBarProps) {
  const roundedPercentage = useMemo(
    () =>
      Math.round((percentage + Number.EPSILON) * Math.pow(10, decimalPlaces)) /
      Math.pow(10, decimalPlaces),
    [percentage, decimalPlaces]
  );
  return (
    <div className={classNames(styles.container, className)} style={{ color }}>
      <div className={styles.progressbar}>
        <CircularProgressbar
          value={percentage}
          styles={buildStyles({
            pathTransitionDuration: 0.5,
          })}
        />
      </div>
      <div
        className={classNames(styles.text, {
          [styles.hideNumber]: hideNumber,
        })}
      >
        {roundedPercentage < 100 ? roundedPercentage : 100}%
      </div>
    </div>
  );
}

export default AscCircularProgressBar;
